module.exports = __webpack_public_path__ + "img/titleA.7920d43e.png";